"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RequestContactImportNewList {
    static getAttributeTypeMap() {
        return RequestContactImportNewList.attributeTypeMap;
    }
}
RequestContactImportNewList.discriminator = undefined;
RequestContactImportNewList.attributeTypeMap = [
    {
        "name": "listName",
        "baseName": "listName",
        "type": "string"
    },
    {
        "name": "folderId",
        "baseName": "folderId",
        "type": "number"
    }
];
exports.RequestContactImportNewList = RequestContactImportNewList;
//# sourceMappingURL=requestContactImportNewList.js.map